export default __webpack_public_path__ + "static/media/youtube.ebb9e54a.svg";